module.exports = __webpack_public_path__ + "img/neo-card-mastercard.9a51ae63.png";